/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-grey[_ngcontent-%COMP%]{background:#585858!important}.portlet-head-layout[_ngcontent-%COMP%]{padding:0 1.4rem!important}.card-header[_ngcontent-%COMP%]{padding:1.35rem 1.05rem!important}.hr-layout-2[_ngcontent-%COMP%]{border-top:1.2px solid #3f4047!important}.c-dark-blue[_ngcontent-%COMP%]{color:#294a75}.fs-45px[_ngcontent-%COMP%]{font-size:45px}.mb-2p2rem[_ngcontent-%COMP%]{margin-bottom:2.2rem}.fs-1p3rem[_ngcontent-%COMP%]{font-size:1.3rem}\n/*# sourceMappingURL=health-risk-assessment-overview.component.css.map*/"];
export { styles as styles };
